import { render, staticRenderFns } from "./NotifyMessageDialog.vue?vue&type=template&id=29be740f&"
import script from "./NotifyMessageDialog.vue?vue&type=script&lang=ts&"
export * from "./NotifyMessageDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports